var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLabel1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.03875 22.1337C11.9308 26.0258 18.2411 26.0258 22.1331 22.1337C26.0252 18.2417 26.0252 11.9314 22.1331 8.03937C18.2411 4.14732 11.9308 4.14732 8.03875 8.03937C4.1467 11.9314 4.1467 18.2417 8.03875 22.1337ZM9.60376 20.5674C12.6315 23.5951 17.5404 23.5951 20.5681 20.5674C23.5958 17.5396 23.5958 12.6307 20.5681 9.603C17.5404 6.57528 12.6315 6.57528 9.60376 9.603C6.57604 12.6307 6.57604 17.5396 9.60376 20.5674Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.3359,
    y: 20.2188,
    width: 10.215,
    height: 2.38165,
    rx: 1.19082,
    transform: "rotate(45 21.3359 20.2188)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabel1);
export default __webpack_public_path__ + "static/media/label-1.4c128879fd8177107a23929e8f53c171.svg";
export { ForwardRef as ReactComponent };